import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Instagram, Facebook, Twitter, Youtube, Mail, Phone, MapPin } from "lucide-react";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer id="contact" className="footer-animate ariglo-footer">
      <div className="footer-shell">
        <div className="footer-top-grid">
          {/* BRAND */}
          <div className="footer-brand-col">
            <div className="footer-brand">
              <Leaf size={22} />
              <span>Ariglo</span>
            </div>
            <p className="footer-brand-text">
              Nurturing beauty through nature’s wisdom with safe, effective, and
              sustainable herbal care.
            </p>
            <div className="footer-contact-list">
              <a href="tel:+919753346858">
                <Phone size={14} />
                <span>+91 9753346858</span>
              </a>
              <a href="mailto:support@ariglo.com">
                <Mail size={14} />
                <span>support@ariglo.com</span>
              </a>
              <p>
                <MapPin size={14} />
                <span>94, Nazarpura, Post Rahatgaon, Dist Harda, Madhya Pradesh - 461228</span>
              </p>
            </div>
          </div>

          {/* SHOP */}
          <FooterList
            title="Shop"
            links={[
              { label: "Face Care", to: "/products" },
              { label: "Hair Care", to: "/products" },
              { label: "Body Care", to: "/products" },
              { label: "Gift Sets", to: "/products" },
            ]}
          />

          {/* COMPANY */}
          <FooterList
            title="Company"
            links={[
              { label: "About Us", to: "/about" },
              { label: "Blog", to: "/blog" },
              { label: "Careers", to: "/careers" },
              { label: "Our Story", to: "/about" },
              { label: "Sustainability", to: "/about" },
              { label: "Contact", to: "/contact" },
            ]}
          />

          {/* SOCIAL */}
          <div>
            <h4 className="footer-heading">Follow Us</h4>
            <div className="footer-social">
              <SocialIcon
                icon={<Instagram />}
                link="https://www.instagram.com/arigloharbal"
                label="Instagram"
              />

              <SocialIcon
                icon={<Facebook />}
                link="https://www.facebook.com/profile.php?id=61586956569400"
                label="Facebook"
              />

              <SocialIcon
                icon={<Twitter />}
                link="https://x.com/ArigloHarbal"
                label="X (Twitter)"
              />

              <SocialIcon
                icon={<Youtube />}
                link="https://www.youtube.com/@Ariglo-harbal"
                label="YouTube"
              />
            </div>
            <p className="footer-note">Follow us for new launches, offers, and herbal care tips.</p>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="footer-bottom">
          <p>© 2026 Ariglo. All rights reserved.</p>

          <div className="footer-legal">
            <Link to="/privacy-policy" className="footer-legal-link">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="footer-legal-link">
              Terms & Conditions
            </Link>
            <Link to="/refund-policy" className="footer-legal-link">
              Refund & Cancellation
            </Link>
            <Link to="/data-deletion" className="footer-legal-link">
              Data Deletion
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ---------- SMALL COMPONENTS ---------- */

function FooterList({ title, links }) {
  return (
    <div>
      <h4 className="footer-heading">{title}</h4>
      <ul className="footer-list">
        {links.map((item) => (
          <li key={item.label}>
            <Link to={item.to} className="footer-link">
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

// function SocialIcon({ icon }) {
//   return (
//     <a
//       href="#"
//       style={{
//         width: "2.6rem",
//         height: "2.6rem",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.12)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         color: "white",
//         transition: "all 0.3s ease",
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.background = "rgba(255,255,255,0.22)";
//         e.currentTarget.style.transform = "translateY(-4px)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.background = "rgba(255,255,255,0.12)";
//         e.currentTarget.style.transform = "translateY(0)";
//       }}
//     >
//       {icon}
//     </a>
//   );
// }

function SocialIcon({ icon, link, label }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="footer-social-icon"
      aria-label={label}
    >
      {icon}
    </a>
  );
}
